// extracted by mini-css-extract-plugin
export var text = "_bd-0";